module.exports = __webpack_public_path__ + "img/avatar0.f1dc5ef9.png";